import { combineReducers } from 'redux';

import mainReducer from './mainReducer';
import mapReducer from './mapReducer';

const reducer = combineReducers({
  main: mainReducer,
  map: mapReducer
});

export default reducer;




// WEBPACK FOOTER //
// ./src/state/reducers/index.js